import projectAnalytics from "@restaurant-store-analytics";

interface Analytics {
  track(event: string, properties?: Record<string, unknown>): void;
}

const analytics: Analytics = projectAnalytics;

export default analytics;
